// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MapActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import { branch, compose, withProps } from 'recompose';
import HighmapActions from './Izenda.HighmapActions';
import GoogleMapsActions from './Izenda.GoogleMapsActions';
import { MAP_TYPES } from 'logic/data/Izenda.ReportPartMapConstants';
import { each, isEmpty, findIndex, take, every, get, first, some, find } from 'lodash/fp';
import { isValidLatLong } from './googlemaps/Izenda.GoogleMapsUtils';
import { PointsOptionsOrder, MappingPointKeys } from 'logic/data/Izenda.ReportPartMapConstants';

function filterValidRecords(currentSeries: Object, type: String) {
  const records = [];

  each(series => {
    each(point => {
      if (
        (type === 'shadingSeries' &&
          point.pointInfo &&
          (!isEmpty(point.pointInfo.coordinates) ||
            !isEmpty(point.pointInfo['woe-id']) ||
            !isEmpty(point.pointInfo['hc-key']))) ||
        (type === 'bubbleSeries' &&
          (isValidLatLong(point.lat, point.lon) || (point.pointInfo && !isEmpty(point.pointInfo['hc-key']))))
      ) {
        records.push(point.record);
      }
    }, series.data);
  }, currentSeries);

  return records;
}

function getGeoPoint(points, record, dataStructure, activePointOptionType) {
  const pointOptionIndex = findIndex(pointOption => pointOption === activePointOptionType, PointsOptionsOrder);
  const pointOptions = take(pointOptionIndex, PointsOptionsOrder);
  const currentMappingPointKey = MappingPointKeys[activePointOptionType];

  const geoPoint = find(point => {
    return every(pointOptionName => {
      const columnName = get('columnName', first(dataStructure[pointOptionName]));
      if (columnName) {
        const value = record[columnName];
        const mappingKeys = currentMappingPointKey[pointOptionName];
        if (!mappingKeys) {
          return true;
        }
        return some(mappingKey => mappingKey.compare(value, point[mappingKey.key]), mappingKeys);
      }
      return true;
    }, pointOptions);
  }, points);

  return geoPoint || first(points);
}

export default compose(
  withProps({
    filterValidRecords,
    getGeoPoint
  }),
  branch(({ chartType }) => chartType === MAP_TYPES.Google, GoogleMapsActions, HighmapActions)
);



// WEBPACK FOOTER //
// ./ui/share/components/charting/Izenda.MapActions.js